module.exports = __webpack_public_path__ + "img/logo.a4e033c8.png";